// extracted by mini-css-extract-plugin
export default {"tabContent":"_2CopC","tabContentActive":"_1TQ7c"};